<!--
  Created by Caroline on 2019/11/25 0025.
-->
<template>
  <div class="container">
    <div class="mask"></div>
    
<!--    <div class="pos_center center" :style="'transform: scale(' + scale + ')'">-->
    <div class="pos_center center" :style="centerStyle">
<!--    <div class="pos_center center">-->
      <img src="https://image-weddinglive.marryou520.com/pc/wait_center.png" alt="" class="center--bg"/>
      
      <div class="center--container">
        <div class="center--title">{{detail.activity.title}}</div>
        <div class="center--qr-box">
<!--          <img :src="shareData ? shareData.qrcodeUrl : ''" alt="" class="center&#45;&#45;qr"/>-->
          <img :src="shareData.qrcodeUrl" alt="" class="center--qr"/>
        </div>
        <div class="center--txt">扫码进入婚礼直播</div>
      </div>
      
    </div>
  </div>
</template>

<script>
  import {mapActions, mapState, mapGetters} from 'vuex'
  
  export default {
    name: "wait",
    data() {
      return {
      }
    },
    watch: {
    },
    computed: {
      ...mapState(['win', 'modeData', 'detail', 'shareData']),
      ...mapGetters(['scale']),
      centerStyle () {
        let style = {
          'transform': 'scale(' + this.scale + ')',
        }
        this.win.screenWScale === 1 ? style['margin'] = 'auto' : style['margin-left'] = this.mainML
        return style
      },
      mainML () {
        let mainML = (980-this.win.winWidth)/2/this.win.winWidth
        mainML = (-mainML*100).toFixed(2) + "%"
        return mainML
      },
    },
    created() {
    },
    methods: {
    }
  }
</script>

<style scoped lang="less">
  @import "../less/common.less";
  @import "../less/wait.less";

</style>



// WEBPACK FOOTER //
// src/components/wait.vue